<template>
  <div class="comment-wrapper" :class="isOwn ? 'own' : 'other'">
    <div class="comment-bubble">
      <div class="comment-author">
        <strong>{{ commentAuthorEmail }}</strong>
      </div>
      <div class="comment-body">
        <RenderVHtml :content="Comment.comment"></RenderVHtml>
      </div>
      <div class="comment-footer">
        <span class="comment-date">{{
          Comment.creation_date | FormatToDateTime
        }}</span>
        <span v-if="Comment.updated_by" class="comment-edited">
          · {{ $t("reusable.common.edited") }}
          {{ Comment.update_date | FormatToDateTime }}
        </span>
        <span
          v-if="user && Comment.created_by == user.email"
          class="comment-actions"
        >
          <ButtonSmall
            :tooltip_text="``"
            :text_button="``"
            :click_button="
              () => $bvModal.show(`edit-comment-modal-${Comment.id}`)
            "
            :icon="'square'"
          ></ButtonSmall>
          <ContainerRichTextKlv3
            :id_modal="`edit-comment-modal-${Comment.id}`"
            :title_modal="
              $t('reusable.common.editModalTitle', {
                entity: $t('toolbar.acts.comment'),
              })
            "
            :size_modal="`lg`"
            :object_rich_text="Comment"
            :content_rich_text="Comment.comment"
            :show_last_modification="true"
            @save="(content) => updateComment(Comment, content)"
            @close="$bvModal.hide(`edit-comment-modal-${Comment.id}`)"
          ></ContainerRichTextKlv3>
          <ButtonSmall
            :tooltip_text="``"
            :text_button="``"
            :click_button="() => askForDeleteComment(Comment.id)"
            :icon="'trash'"
          ></ButtonSmall>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ActComments",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
  },

  props: {
    Comment: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    commentAuthorEmail() {
      // created_by ya trae el email desde el backend
      return this.Comment.created_by || "";
    },
    isOwn() {
      return this.user && this.Comment.created_by == this.user.email;
    },
  },
  methods: {
    askForDeleteComment(id) {
      this.$emit("delete_comment", id);
    },
    updateComment(object, text) {
      this.$emit("update_comment", { id: object.id, comment: text });
    },
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scoped>
.comment-wrapper {
  display: flex;
  margin-bottom: var(--kl-space-3);
}

/* Comentario propio: alineado a la derecha */
.comment-wrapper.own {
  justify-content: flex-end;
}

/* Comentario de otro: alineado a la izquierda */
.comment-wrapper.other {
  justify-content: flex-start;
}

.comment-bubble {
  min-width: 100%;
  border-radius: var(--kl-radius-lg);
  padding: 0.6rem 0.9rem 0.4rem;
  position: relative;
}

.comment-wrapper.own .comment-bubble {
  background: var(--kl-surface-muted);
  border-bottom-right-radius: var(--kl-radius-sm);
}

.comment-wrapper.other .comment-bubble {
  background: var(--kl-surface-muted);
  border-bottom-left-radius: var(--kl-radius-sm);
}

.comment-author {
  font-size: var(--kl-fs-small);
  margin-bottom: 0.25rem;
}

.comment-wrapper.own .comment-author {
  text-align: right;
}

.comment-body {
  color: var(--kl-text-body);
  line-height: var(--kl-lh-base);
}

.comment-body >>> p {
  margin-bottom: 0.25rem;
}

.comment-body >>> p:last-child {
  margin-bottom: 0;
}

.comment-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.2rem;
  margin-top: 0.3rem;
}

.comment-date {
  font-size: var(--kl-fs-caption);
  color: var(--kl-text-muted);
}

.comment-edited {
  font-size: var(--kl-fs-caption);
  color: var(--kl-text-muted);
  font-style: italic;
}

.comment-actions {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  margin-left: 0.3rem;
}
</style>